import styled from 'styled-components';

export const StepContainer = styled.div`
  padding: 24px;
  min-height: 400px;
`;

export const StepTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 24px;
  color: #333;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #555;

  ${(props) =>
    props.required &&
    `
    &::after {
      content: ' *';
      color: #f44336;
    }
  `}
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    border-color: #2196f3;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #2196f3;
  }

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #555;
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #555;
  cursor: pointer;

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

export const SummaryContainer = styled.div`
  padding: 24px;
  background-color: #f8f9fa;
  border-radius: 8px;
`;

export const SummarySection = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SummarySectionTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
  border-bottom: 2px solid #2196f3;
  padding-bottom: 8px;
`;

export const SummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;

  strong {
    color: #555;
    font-weight: 500;
  }

  span {
    color: #333;
  }
`;

export const ValueDisplay = styled.div`
  background-color: white;
  padding: 16px;
  border-radius: 4px;
  margin-top: 16px;
  border: 1px solid #e0e0e0;
`;

export const ValueRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;

  &:not(:last-child) {
    border-bottom: 1px solid #f0f0f0;
  }

  strong {
    color: #555;
  }

  span {
    color: #333;
    font-weight: 500;
  }
`;

export const PercentageInputGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
`;

export const HelpText = styled.p`
  font-size: 12px;
  color: #666;
  margin-top: 4px;
  font-style: italic;
`;

export const ErrorText = styled.p`
  font-size: 12px;
  color: #f44336;
  margin-top: 4px;
`;

export const InfoBox = styled.div`
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
  padding: 12px 16px;
  margin: 16px 0;
  border-radius: 4px;
  font-size: 14px;
  color: #1976d2;
`;
